// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/carburetor-icing.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/carburetor-icing/carburetor-icing.js';

mount([g0]);
